import { createStore } from "owa-satcheljs";
import type { GroupsState, GroupsStateByMailboxInfo } from "./schema/GroupsState";
import type { AccountKey } from "owa-client-types";

export const getGroupsStore: () => GroupsStateByMailboxInfo = createStore<GroupsStateByMailboxInfo>("groupsStore", {
    groupsStateByMailboxInfo: new Map<AccountKey, GroupsState>(),
});
